import { render, staticRenderFns } from "./RuleAdGroup.vue?vue&type=template&id=0b8721d4"
import script from "./RuleAdGroup.vue?vue&type=script&lang=js"
export * from "./RuleAdGroup.vue?vue&type=script&lang=js"
import style0 from "./RuleAdGroup.vue?vue&type=style&index=0&id=0b8721d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports